import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type AncStatusBadgeTone =
    | 'neutral'
    | 'negative'
    | 'positive'
    | 'alert'
    | 'info';

/**
 * Tonal status pill with an optional leading dot. Projects its label via content
 * so callers can run text through translate or interpolate it as needed.
 */
@Component({
    selector: 'lib-anc-status-badge',
    imports: [CommonModule],
    templateUrl: './anc-status-badge.component.html',
    styleUrls: ['./anc-status-badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncStatusBadgeComponent {
    /** Tonal treatment. */
    tone = input<AncStatusBadgeTone>('neutral');
    /** Show a leading status dot. */
    dot = input<boolean>(false);
}
